/* eslint-disable jsx-a11y/anchor-is-valid */
import { forwardRef } from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { CgPlayListRemove } from '@react-icons/all-files/cg/CgPlayListRemove'
import { AiOutlineClose } from '@react-icons/all-files/ai/AiOutlineClose'

import useSetMylist from '../hooks/useSetMylist'

const MyList = forwardRef(({ isShowMyList, setIsShowMyList }, ref) => {
	const { menu, marketUpdate } = useSelector(state => state.mylist)
	const { setMyList } = useSetMylist()

	return (
		<div className={`my-list-wrapper ${isShowMyList ? 'open' : ''}`} ref={ref}>
			<button
				className="btn secondary min-h-0 absolute right-5 top-3"
				onClick={() => setIsShowMyList(false)}
			>
				<AiOutlineClose />
				<span>Close</span>
			</button>

			<div className="container mx-auto py-11">
				<div className="grid grid-cols-3 gap-7">
					<div>
						<h2 className="text-ci1 text-bold text-base">Your List Menu</h2>
						<ul className="leading-relaxed mt-3">
							{menu?.map(item => (
								<li key={item.menuID} className="border-b py-1">
									{item.isBiPage ? (
										<div className="flex items-center justify-between">
											<a
												href={item.biLink}
												target="_blank"
												rel="noreferrer"
												onClick={() => setIsShowMyList(false)}
											>
												{item.menuName}
											</a>
											<a
												title="Remove from my list"
												onClick={() => {
													setMyList(item.menuID, false)
												}}
											>
												<CgPlayListRemove size={18} />
											</a>
										</div>
									) : (
										<div className="flex items-center justify-between">
											<Link to={item.link}>{item.menuName}</Link>
											<a
												title="Remove from my list"
												onClick={() => setMyList(item.menuID, false)}
											>
												<CgPlayListRemove size={18} />
											</a>
										</div>
									)}
								</li>
							))}
						</ul>
					</div>

					{marketUpdate?.map(item => {
						return (
							<div key={item.newsId}>
								<div className="flex mt-3">
									{item.thumbnail ? (
										<img
											className="self-start w-20 lg:w-32 xl:w-40"
											alt=""
											src={`${process.env.REACT_APP_BASE_ASSETS}${item.thumbnail}`}
										/>
									) : (
										<img
											className="self-start w-20 lg:w-32 xl:w-40"
											alt=""
											src={`${
												process.env.PUBLIC_URL
											}/images/market-update/default-${item.workstreamCode?.toLowerCase()}.jpg`}
										/>
									)}

									<div className="ml-3">
										<p className="line-clamp-3">
											{item.myListLink.startsWith('http') ? (
												<a
													href={item.myListLink}
													target="_blank"
													rel="noreferrer"
													onClick={() => setIsShowMyList(false)}
												>
													{item.subject}
												</a>
											) : (
												<Link to={item.myListLink}>{item.subject}</Link>
											)}
										</p>
									</div>
								</div>
							</div>
						)
					})}
				</div>
			</div>
		</div>
	)
})

export default MyList
